/**
 * Hook for tag suggestions/autocomplete
 */

import { useQuery } from "@tanstack/react-query";
import { erp } from "@/lib/erp";

type UseTagSuggestionsOptions = {
  enabled?: boolean; // Has permission to edit
  isOpen?: boolean; // Dropdown is open
  minLength?: number; // Minimum characters before fetching (default 2)
};

export function useTagSuggestions(
  doctype: string,
  searchText: string,
  options: UseTagSuggestionsOptions = {}
) {
  const { enabled = true, isOpen = false, minLength = 2 } = options;

  // Only fetch if:
  // - enabled (has permission)
  // - dropdown is open
  // - searchText meets minimum length (or empty for initial suggestions if minLength === 0)
  const effectiveEnabled =
    enabled &&
    isOpen &&
    (searchText.length >= minLength || (searchText.length === 0 && minLength === 0));

  return useQuery({
    queryKey: ["tag-suggestions", doctype, searchText],
    queryFn: () => erp.docs.getTagSuggestions(doctype, searchText),
    enabled: effectiveEnabled,
    staleTime: 30_000, // Cache for 30 seconds
  });
}

